export const getSessionIdFromName = (name) => {
  if (!name || typeof name !== "string") return null;

  const parts = name.split("/sessions/");
  if (parts.length > 1) {
    const maybeId = parts[1].split("/")[0];
    return maybeId || null;
  }

  const fallback = name.split("/");
  return fallback[fallback.length - 1] || null;
};
